<template>
  <div>
    <SocialHeader></SocialHeader>
    <router-view class="social_router_view"></router-view>
    <SocialFooter></SocialFooter>
  </div>
</template>
<script>
import SocialHeader from '@/components/base/BaseHeader'
import SocialFooter from '@/components/base/BaseFooter'
export default {
  name: "Social",
  components: {
    'SocialHeader': SocialHeader,
    'SocialFooter': SocialFooter,
  },
}
</script>
<style>
  .social_router_view{
    min-height: calc(100vh - 162px);
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
</style>